import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import BottomNav from '../components/BottomNav';
import QRCode from '../components/QRCode';
import { useLang } from '../LangContext';
import { useT } from '../i18n';

export default function MemberBarcodeScreen() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = useT(lang);

  return (
    <div style={{
      backgroundColor: '#1A1A2E',
      minHeight: '100dvh',
      paddingTop: 56,
      paddingBottom: 96,
      fontFamily: "'Be Vietnam Pro', sans-serif",
      color: '#ffffff',
    }}>
      <TopBar dark />

      <div style={{ padding: '28px 24px', maxWidth: 480, margin: '0 auto' }}>

        {/* ── Section header ───────────────────────── */}
        <div style={{ marginBottom: 28 }}>
          <h1 style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 800, fontSize: 28, color: '#ffffff', lineHeight: 1.2, marginBottom: 4,
          }}>{t('memberCard')}</h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>
            {t('scanToEarn')}
          </p>
        </div>

        {/* ── Main Member Card ─────────────────────── */}
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: 32,
          overflow: 'hidden',
          boxShadow: '0px 20px 60px rgba(0,0,0,0.4)',
          position: 'relative',
          marginBottom: 20,
        }}>
          {/* Decorative blur */}
          <div style={{
            position: 'absolute', top: -48, right: -48,
            width: 160, height: 160,
            backgroundColor: 'rgba(249,204,97,0.2)',
            borderRadius: '50%', filter: 'blur(48px)',
          }}/>

          <div style={{ padding: 28, position: 'relative', zIndex: 1 }}>
            {/* Points + tier */}
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              marginBottom: 24,
            }}>
              <div>
                <span style={{
                  fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.12em',
                  color: 'rgba(45,45,66,0.4)', fontWeight: 700,
                }}>
                  {t('currentBalance')}
                </span>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginTop: 2 }}>
                  <span style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontWeight: 800, fontSize: 36, color: '#2d2d42', letterSpacing: '-0.03em', lineHeight: 1,
                  }}>2,480</span>
                  <span style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontWeight: 700, fontSize: 13, color: '#b02600',
                  }}>PTS</span>
                </div>
              </div>
              <div style={{
                backgroundColor: '#f9cc61',
                color: '#443100',
                padding: '6px 14px',
                borderRadius: 16,
                display: 'flex', alignItems: 'center', gap: 6,
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
                <span style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.05em',
                }}>{t('goldTier')}</span>
              </div>
            </div>

            {/* QR + Barcode section */}
            <div style={{
              backgroundColor: '#f2efff',
              padding: 20,
              borderRadius: 24,
              display: 'flex', flexDirection: 'column', alignItems: 'center',
              border: '1px solid rgba(45,45,66,0.05)',
              marginBottom: 24,
            }}>
              {/* QR Code */}
              <div style={{
                backgroundColor: '#ffffff',
                padding: 14,
                borderRadius: 12,
                boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.04)',
                marginBottom: 20,
              }}>
                <QRCode size={176} color="#1A1A2E" bg="#ffffff"/>
              </div>

              {/* Barcode strips */}
              <div style={{ width: '100%' }}>
                <div style={{
                  height: 48,
                  backgroundImage: `repeating-linear-gradient(
                    90deg,
                    transparent, transparent 2px,
                    #1A1A2E 2px, #1A1A2E 4px
                  )`,
                  opacity: 0.8,
                  marginBottom: 8,
                }}/>
                <div style={{
                  textAlign: 'center',
                  fontFamily: 'monospace',
                  fontSize: 11,
                  letterSpacing: '0.3em',
                  color: '#2d2d42',
                  fontWeight: 500,
                  textTransform: 'uppercase',
                }}>BC-4829-9102-3341</div>
              </div>
            </div>

            {/* Instruction */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{
                width: 40, height: 40, borderRadius: '50%',
                backgroundColor: 'rgba(176,38,0,0.1)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#b02600">
                  <path d="M3 11h4v2H3v-2zm4-4H5V5H3v2h4V5h2v2H7zM3 7h2V5H3v2zm8 0h2V5h-2v2zm-4 0h2V5H7v2zm8 4h-2v2h2v-2zm-4-4v2h2V7h-2zm4 0h-2v2h2V7zM3 17h4v2H3v-2zm4-4H3v2h4v2h2v-4H7zm2 4h2v-2H9v2zm4-4h-2v4h4v-2h-2v-2zm-4-2h2v-2H9v2z"/>
                </svg>
              </div>
              <p style={{ fontSize: 13, color: '#2d2d42', fontWeight: 600 }}>
                {t('scanToEarnRedeem')}
              </p>
            </div>
          </div>

          {/* Bottom accent stripe */}
          <div style={{ backgroundColor: '#b02600', height: 8 }}/>
        </div>

        {/* ── Tier progress grid ───────────────────── */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 24 }}>
          <div style={{
            backgroundColor: 'rgba(255,255,255,0.05)',
            borderRadius: 24, padding: 18,
            border: '1px solid rgba(255,255,255,0.1)',
          }}>
            <span style={{
              fontSize: 9, color: 'rgba(255,255,255,0.4)', fontWeight: 700,
              textTransform: 'uppercase', letterSpacing: '0.12em', display: 'block', marginBottom: 6,
            }}>{t('nextReward')}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700, fontSize: 18, color: '#f9cc61',
              }}>520</span>
              <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>{t('toGo')}</span>
            </div>
            <div style={{
              width: '100%', height: 6, borderRadius: 9999,
              backgroundColor: 'rgba(255,255,255,0.1)',
              marginTop: 10, overflow: 'hidden',
            }}>
              <div style={{ width: '70%', height: '100%', backgroundColor: '#f9cc61', borderRadius: 9999 }}/>
            </div>
          </div>

          <div style={{
            backgroundColor: 'rgba(255,255,255,0.05)',
            borderRadius: 24, padding: 18,
            border: '1px solid rgba(255,255,255,0.1)',
            display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
          }}>
            <span style={{
              fontSize: 9, color: 'rgba(255,255,255,0.4)', fontWeight: 700,
              textTransform: 'uppercase', letterSpacing: '0.12em', display: 'block',
            }}>{t('availableCoupons')}</span>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 }}>
              <span style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700, fontSize: 28, color: '#ffffff',
              }}>03</span>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#FF5C36">
                <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/>
              </svg>
            </div>
          </div>
        </div>

        {/* ── Quick Actions ────────────────────────── */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button style={{
            height: 52, width: '100%',
            backgroundColor: '#FF5C36', color: '#ffffff',
            border: 'none', borderRadius: 14,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700, fontSize: 14, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.3), 0 4px 12px rgba(176,38,0,0.4)',
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
            </svg>
            {t('topUpBalance')}
          </button>
          <button
            onClick={() => navigate('/event')}
            style={{
              height: 52, width: '100%',
              backgroundColor: 'transparent',
              border: '2px solid rgba(255,92,54,0.3)', color: '#FF5C36',
              borderRadius: 14,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>
            </svg>
            {t('transactionHistory')}
          </button>
        </div>

      </div>

      <BottomNav />
    </div>
  );
}
